import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminVerifactuAuthorizationModel } from '../../models/admin-verifactu-authorization.model';

@Component({
    selector: 'admin-verifactu-authorization-list',
    templateUrl: './admin-verifactu-authorization-list.component.html',
    styleUrls: ['./admin-verifactu-authorization-list.component.css'],
    standalone: false
})
export class AdminVerifactuAuthorizationListComponent {
  @Input() auths: AdminVerifactuAuthorizationModel[] = [];
  @Output() downloadRequested = new EventEmitter<string>();
  @Output() validateRequested = new EventEmitter<string>();
  @Output() revokeRequested = new EventEmitter<string>();
  loading = false;

  downloadAuthorization(uid: string): void {
    this.downloadRequested.emit(uid);
  }

  validateAuthorization(uid: string): void {
    this.validateRequested.emit(uid);
  }

  revokeAuthorization(uid: string): void {
    this.revokeRequested.emit(uid);
  }
  public trackByIndex(i: number) { return i; }

}